import { render } from "./ComponentPropertyBoard.vue?vue&type=template&id=7870d736&scoped=true"
import script from "./ComponentPropertyBoard.vue?vue&type=script&lang=js"
export * from "./ComponentPropertyBoard.vue?vue&type=script&lang=js"

import "./ComponentPropertyBoard.vue?vue&type=style&index=0&id=7870d736&scoped=true&lang=css"

import exportComponent from "/builds/tumeda/flui3d-mold/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7870d736"]])

export default __exports__